import React from 'react';
import { useParams } from 'react-router-dom';

import ReportDisplay from './ReportDisplay';
import ReportViewportArea from './ReportViewportArea';
import { ReportDetailViewportWrapper } from './reportsViewStyles';

export default function ReportDisplayPage() {
  const { reportId } = useParams();

  return (
    <ReportDetailViewportWrapper>
      <ReportViewportArea>
        <ReportDisplay reportId={reportId} />
      </ReportViewportArea>
    </ReportDetailViewportWrapper>
  );
}
